import { PRIVACY_LINK, TERMS_LINK } from '@User/components/HyperLinks'

import {
    GUIDE_3DP,
    GUIDE_CNC,
    GUIDE_FINISH,
    GUIDE_IM,
    GUIDE_RTV,
} from '~/lib/partsConstants'
import { isJapan, isUs } from '~/lib/appRegionConstants'
import { HELP_EMAIL } from '~/lib/emailAndUrls'
import { mailtoLink } from '~/lib/mailtoLink'
import { getenv } from '~/settings'

const linkForGetQuestionAnswered = () => {
    if (isJapan()) {
        return `${mailtoLink(HELP_EMAIL, 'I need help!')}`
    } else if (isUs()) {
        return `${getenv('REGIONAL_CONFIGS')?.urls?.help_center}`
    } else {
        return ''
    }
}

export const CARD_LIST = [
    {
        title: 'How to get started',
        description:
            'A comprehensive walkthrough for uploading and configuring your parts',
        icon: 'play-circle',
        antdIcon: true,
        iconDescription: 'Video',
        link: `${
            getenv('REGIONAL_CONFIGS')?.urls?.getting_started_with_fictiv
        }`,
    },
    {
        title: 'Try a sample part',
        description:
            'Download a sample part file to test process and configuration options',
        icon: 'cubeIcon',
        antdIcon: false,
        iconDescription: 'Test',
        link: 'https://fictivcdn.com/static/parts/Fictiv-Triangle-Demo-Part.sldprt',
    },
    {
        title: 'Get questions answered',
        description:
            'Find answers to popular questions about  our ordering process',
        icon: 'question-circle',
        antdIcon: true,
        iconDescription: 'FAQ',
        link: linkForGetQuestionAnswered(),
    },
    {
        title: 'Explore our capabilities',
        description: 'CNC Machining, Injection Molding, 3D Printing and more',
        icon: 'tool',
        antdIcon: true,
        iconDescription: 'Process',
        hasSubMenu: true,
        link: '',
    },
    {
        title: 'View customer stories',
        description: 'See why our customers trust us with their parts',
        icon: 'team',
        antdIcon: true,
        iconDescription: 'Testimonials',
        link: `${getenv('REGIONAL_CONFIGS')?.urls?.case_studies}`,
    },
]

const FOOTER_LINKS_JP = [
    {
        id: 'about-fictiv',
        name: 'About Fictiv',
        link: `${getenv('REGIONAL_CONFIGS')?.urls?.our_platform}`,
    },
    {
        id: 'terms-of-service',
        name: 'Terms of Service',
        link: TERMS_LINK,
    },
]

const footerLinks = () => {
    if (isJapan()) {
        return FOOTER_LINKS_JP
    } else if (isUs()) {
        return [
            ...FOOTER_LINKS_JP,
            {
                id: 'privacy-policy',
                name: 'Privacy Policy',
                link: PRIVACY_LINK,
            },
        ]
    } else {
        return []
    }
}

export const FOOTER_LINKS = footerLinks()

export const SUB_MENU_LINKS = [
    {
        name: 'CNC Machining',
        link: GUIDE_CNC,
    },
    {
        name: '3D Printing',
        link: GUIDE_3DP,
    },
    {
        name: 'Injection Molding',
        link: GUIDE_IM,
    },
    {
        name: 'Urethane Casting',
        link: GUIDE_RTV,
    },
    {
        name: 'Finishing Services',
        link: GUIDE_FINISH,
    },
]
